import React from "react";
import styles from "./styles.module.css";
import classNames from "classnames";

interface gameSelectShopCardProps {
  game: string;
  onClick?: () => void;
}

export const GameSelectShopCard: React.FC<gameSelectShopCardProps> = ({
  game,
  onClick,
}) => {
  // Определяем, является ли игра доступной
  const isComingSoon = game !== "CSGO";
  
  // Обработчик клика с предотвращением для недоступных игр
  const handleClick = () => {
    if (!isComingSoon && onClick) {
      onClick();
    }
  };

  switch (game) {
    case "CSGO":
      return (
        <div
          className={classNames(styles.container, styles.csgo)}
          onClick={onClick}
        >
          <div className={styles.empty}></div>
          <div className={styles.gameName}>
            <img src="/icons/GameIcons/CounterStrike2.svg" alt="CS2" className={styles.gameIcon} />
            <p className={styles.gameP}>CS2</p>
          </div>
        </div>
      );
    
    case "DOTA2":
      return (
        <div
          className={classNames(styles.container, styles.dota2, { [styles.comingSoonContainer]: isComingSoon })}
          onClick={handleClick}
        >
          <div className={styles.empty}></div>
          <div className={styles.gameName}>
            <img src="/icons/GameIcons/Dota2.svg" alt="Dota 2" className={styles.gameIcon} />
            <p className={styles.gameP}>DOTA 2</p>
          </div>
          {isComingSoon && <div className={styles.comingSoonOverlay}><span>COMING SOON</span></div>}
        </div>
      );
    
    case "MARVEL":
      return (
        <div
          className={classNames(styles.container, styles.marvel, { [styles.comingSoonContainer]: isComingSoon })}
          onClick={handleClick}
        >
          <div className={styles.empty}></div>
          <div className={styles.gameName}>
            <img src="/icons/GameIcons/MarvelRivals.svg" alt="Marvel Rivals" className={styles.gameIcon} />
            <p className={styles.gameP}>PUBG</p>
          </div>
          {isComingSoon && <div className={styles.comingSoonOverlay}><span>COMING SOON</span></div>}
        </div>
      );
    
    default:
      return (
        <div 
          className={classNames(styles.container, styles.unknown, { [styles.comingSoonContainer]: isComingSoon })}
          onClick={handleClick}
        >
          <div className={styles.empty}></div>
          <div className={styles.gameName}>
            <svg
              width="36"
              height="64"
              viewBox="0 0 36 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6418 43.8652C11.3433 43.8652 11.0746 43.7753 10.8358 43.5955C10.6567 43.3558 10.5672 43.0861 10.5672 42.7865V39.9101C10.5672 36.9139 11.1642 34.5169 12.3582 32.7191C13.6119 30.8614 15.403 28.9139 17.7313 26.8764C19.6418 25.1985 21.0448 23.7603 21.9403 22.5618C22.8358 21.3034 23.2836 19.7753 23.2836 17.9775C23.2836 16.0599 22.806 14.5318 21.8507 13.3933C20.9552 12.1948 19.7612 11.5955 18.2687 11.5955C16.5373 11.5955 15.1642 12.2247 14.1493 13.4831C13.1343 14.6816 12.6269 16.2996 12.6269 18.3371V19.7753C12.6269 20.4345 12.2687 20.764 11.5522 20.764L1.07463 20.3146C0.776119 20.3146 0.507463 20.2247 0.268657 20.0449C0.0895522 19.8052 0 19.5356 0 19.236V18.3371C0 14.7416 0.776119 11.5655 2.32836 8.80899C3.8806 5.99251 6.0597 3.83521 8.86567 2.33708C11.6716 0.779027 14.8955 0 18.5373 0C23.8507 0 28.0896 1.61798 31.2537 4.85393C34.4179 8.02996 36 12.2547 36 17.5281C36 20.1648 35.6119 22.4419 34.8358 24.3596C34.1194 26.2172 33.2239 27.7453 32.1493 28.9438C31.1343 30.1423 29.791 31.4607 28.1194 32.8989C26.3881 34.397 25.1045 35.6854 24.2687 36.764C23.4925 37.8427 23.1045 39.161 23.1045 40.7191V42.7865C23.1045 43.0861 22.9851 43.3558 22.7463 43.5955C22.5672 43.7753 22.3284 43.8652 22.0298 43.8652H11.6418ZM16.8358 64C14.806 64 13.1343 63.3408 11.8209 62.0225C10.5075 60.7041 9.85075 58.9963 9.85075 56.8989C9.85075 54.8015 10.5075 53.1236 11.8209 51.8652C13.1343 50.5468 14.806 49.8876 16.8358 49.8876C18.9254 49.8876 20.6269 50.5468 21.9403 51.8652C23.2537 53.1835 23.9104 54.8614 23.9104 56.8989C23.9104 58.9363 23.2537 60.6442 21.9403 62.0225C20.6269 63.3408 18.9254 64 16.8358 64Z"
                fill="white"
              />
            </svg>
            <p className={styles.gameP}>UNKNOWN</p>
          </div>
          {isComingSoon && <div className={styles.comingSoonOverlay}><span>COMING SOON</span></div>}
        </div>
      );
  }
};
